import { useState } from 'react';

import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Tab2 from './Tab2';
const Tab1 = ({ pageState, isLoading, itemCodeList, handleChange }) => {

  console.log(isLoading, "isLoading",);

  if (isLoading) {
    return <p>Loading...</p>; // or show a skeleton loader
  }
  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Details</p>
      </div>

      <div className="col-6 ">
        <div className="mb-3">
          <Input
            id="SerialNo"
            readOnly
            label="Serial No"
            style={{
              height: "30px",

            }}
            value={pageState?.serialNo || ""}
            onChange={(e) => handleChange('serialNo', e.target.value)}

          />
        </div>
      </div>

      <div className="col-6">
        <div >
       <Input
            id="SerialNo"
            readOnly
            label="Item Code"
            style={{
              height: "30px",

            }}
            value={pageState?.itemCode || ""}
            onChange={(e) => handleChange('serialNo', e.target.value)}

          />
        </div>
      </div>

    </div>

  );
};

export default Tab1;